import { render } from "./poll-v1-overlay.vue?vue&type=template&id=4d4fc60e"
import script from "./poll-v1-overlay.vue?vue&type=script&lang=js"
export * from "./poll-v1-overlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__